import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Config from "../config";

const useSecurityAndUIProtections = (mainContentRef) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll to top on route change
  useEffect(() => {
    if (Config.ENV_LABEL === "production") {
      window.scrollTo(0, 0);
      if (mainContentRef?.current) {
        mainContentRef.current.scrollTop = 0;
      }
    }
  }, [location]);

  // Detect DevTools
  useEffect(() => {
    if (Config.ENV_LABEL === "production") {
      const threshold = 160;
      const detectDevTools = () => {
        const devtoolsOpen =
          window.outerWidth - window.innerWidth > threshold ||
          window.outerHeight - window.innerHeight > threshold;

        if (devtoolsOpen) {
          alert("DevTools detected. You are being logged out.");
          localStorage.clear();
          sessionStorage.clear();
          navigate("/auth/login");
        }
      };

      const intervalId = setInterval(detectDevTools, 1000);
      return () => clearInterval(intervalId);
    }
  }, [navigate]);

  // Disable right-click and shortcuts
  useEffect(() => {
    if (Config.ENV_LABEL === "PRODUCTION") {
      const handleContextMenu = (e) => e.preventDefault();

      const handleShortcutBlock = (e) => {
        const key = e.key.toUpperCase();
        if (
          key === "F12" ||
          (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(key)) ||
          (e.ctrlKey && key === "U")
        ) {
          e.preventDefault();
          alert("Shortcut blocked.");
        }
      };

      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("keydown", handleShortcutBlock);

      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("keydown", handleShortcutBlock);
      };
    }
  }, []);
};

export default useSecurityAndUIProtections;
